import { render, staticRenderFns } from "./huayue-info.vue?vue&type=template&id=d538bee4&scoped=true&"
import script from "./huayue-info.vue?vue&type=script&lang=js&"
export * from "./huayue-info.vue?vue&type=script&lang=js&"
import style0 from "./huayue-info.vue?vue&type=style&index=0&id=d538bee4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d538bee4",
  null
  
)

export default component.exports